import {  useState } from "react";
import { Modal } from "react-bootstrap";
import Lightbox from "yet-another-react-lightbox";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Counter from "yet-another-react-lightbox/plugins/counter";
import Download from "yet-another-react-lightbox/plugins/download";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/counter.css";

/**
 * Create a custom component which will render machine images
 * @param props
 * @returns Machine's Images component
 */
export const ViewPhotoGallery = ({images,openViewGallery,closeViewGallery}) => {
  const [isMutation, setIsMutation] = useState(false);
  const [loading, setLoading] = useState(false);
  const [machineImages, setMachineImages] = useState(images);
  const [lightboxIsOpen, setLightboxIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [imagesSet, setImagesSet] = useState([]); 
  const inline = {
    style: {
      width: "100%",
      maxWidth: "100%",
      aspectRatio: "3 / 2",
      margin: "0 auto",
    },
  };
  






  const openLightbox = (index) => {
    setPhotoIndex(index);
    setLightboxIsOpen(true);
  };

  const closeLightbox = () => {
    setLightboxIsOpen(false);
  };

  return (
    <>
    
      <Modal
        show={openViewGallery}
        onHide={closeViewGallery}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        centered
      >
        <Modal.Header closeButton> 
          <Modal.Title>Photo Gallery</Modal.Title> 
        </Modal.Header>
        <Modal.Body className="photo-gallery-cover">
        <div className="row">
            {machineImages.length > 0
            ? machineImages?.map((image, index) => (
                <div className="col-md-4">
                  <div className="photo-gallery-img">
                    
                    <img src={image.src} alt="Photo Gallery"  onClick={() => openLightbox(index)} className="cursor-pointer" />
                  </div>
                </div>
              ))
            : ""}


            {lightboxIsOpen && (  
                  <Lightbox
                  index={photoIndex}
                  open={lightboxIsOpen}
                  close={closeLightbox}
                  slides={machineImages}                                 
                  plugins={[ Fullscreen, Slideshow, Thumbnails, Zoom,Counter,Download]}
                  counter={{ container: { style: { top: 0 } } }}    
                />
                
                )}

            </div>
        </Modal.Body>
      </Modal>

    </>
  );
};
